import React from 'react';
import { Settings, BarChart2 } from 'lucide-react';
import { Card } from '../../../components/ui/Card';

interface TabNavigationProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  t: (key: string) => string;
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  activeTab,
  onTabChange,
  t
}) => {
  return (
    <Card className="mb-6">
      <div className="flex border-b border-border">
        <button
          onClick={() => onTabChange('configuration')}
          className={`flex-1 px-6 py-4 text-sm font-semibold transition-colors flex items-center justify-center gap-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary ${
            activeTab === 'configuration'
              ? 'text-primary border-b-2 border-primary bg-primary/5'
              : 'text-muted-foreground hover:text-foreground hover:bg-muted'
          }`}
        >
          <Settings className="w-[18px] h-[18px]" />
          {t('Profile Configuration')}
        </button>
        <button
          onClick={() => onTabChange('interactions')}
          className={`flex-1 px-6 py-4 text-sm font-semibold transition-colors flex items-center justify-center gap-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary ${
            activeTab === 'interactions'
              ? 'text-primary border-b-2 border-primary bg-primary/5'
              : 'text-muted-foreground hover:text-foreground hover:bg-muted'
          }`}
        >
          <BarChart2 className="w-[18px] h-[18px]" />
          {t('Profile Interactions')}
        </button>
      </div>
    </Card>
  );
};

export default TabNavigation;
